export default function authHeader() {
  const user = localStorage.getItem("user");
  // console.log(user);

  if (!user) {
    return { Authorization: `Bearer ${user}` };
  }
  return { Authorization: `Bearer ${user}` };
}
